import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getService } from "@/services/apiService.ts";
import { setShop } from "@/utils/auth.ts";

export interface Shop {
    _id: string;
    name: string;
    type: string;
    address: string;
    phoneNumber: string;
    cuisineType: string[];
    links: Links;
    images: Images;
    status: boolean;
    __v: number;
    categories: Category[];
    products: Product[];
}

export interface Category {
    _id: string;
    businessId: string;
    name: string;
    sort: number;
    status: boolean;
    __v: number;
}

export interface Images {
    logo: string;
    banner: string;
}

export interface Links {
    map: string;
    youtube: string;
    facebook: string;
    telegram: string;
    instagram: string;
}

export interface Product {
    _id: string;
    businessId: string;
    categoryId: string;
    name: string;
    price: number;
    description: string;
    sort: number;
    status: boolean;
    __v: number;
}

const initialState: Shop = {
    _id: '',
    name: '',
    type: '',
    address: '',
    phoneNumber: '',
    cuisineType: [],
    links: { map: '', youtube: '', facebook: '', telegram: '', instagram: '' },
    images: { logo: '', banner: '' },
    status: false,
    __v: 0,
    categories: [],
    products: []
}

export const getShopDetails = createAsyncThunk(
    'shop/getShopDetails',
    async (id: string, { rejectWithValue }) => {
        try {
            const response = await getService({ url: `businesses/${id}` });
            setShop(response.data as any);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    }
);

const shopSlice = createSlice({
    name: "shop",
    initialState,
    reducers: {
        clearShop: (state) => {
            state._id = '';
            state.name = '';
            state.type = '';
            state.address = '';
            state.phoneNumber = '';
            state.cuisineType = [];
            state.links = { map: '', youtube: '', facebook: '', telegram: '', instagram: '' };
            state.images = { logo: '', banner: '' };
            state.status = false;
            state.__v = 0;
            state.categories = [];
            state.products = [];
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getShopDetails.fulfilled, (state, action: PayloadAction<any>) => {
                state._id = action.payload._id;
                state.name = action.payload.name;
                state.type = action.payload.type;
                state.address = action.payload.address;
                state.phoneNumber = action.payload.phoneNumber;
                state.cuisineType = action.payload.cuisineType;
                state.links = action.payload.links;
                state.images = action.payload.images;
                state.status = action.payload.status;
                state.__v = action.payload.__v;
                state.categories = action.payload.categories;
                state.products = action.payload.products;
            });
    },
}
);

export default shopSlice.reducer